export const weekDays = [
  { value: 'Mon', text: 'Mon' },
  { value: 'Tue', text: 'Tue' },
  { value: 'Wed', text: 'Wed' },
  { value: 'Thu', text: 'Thu' },
  { value: 'Fri', text: 'Fri' },
  { value: 'Sat', text: 'Sat' },
  { value: 'Sun', text: 'Sun' },
];
